<template>
  <div
    v-for="n in 6"
    :key="n"
    class="animate-pulse"
    aria-hidden="true"
  >
    <div class="aspect-video rounded-md bg-gray-100" />
    <div class="mt-3 h-6 w-24 rounded bg-gray-100" />
  </div>
</template>
